import axios from "./http";
import api from "./api";

const formDataConfig = {
  headers: { "Content-Type": "mutipart/form-data" },
};

// let baseUrl = process.env.NODE_ENV === 'production' ? 'http://eliveapi.ttmna.com' : '/obapi' //window.newlive
let baseUrl = process.env.NODE_ENV === "production" ? "/h5/api" : "/obapi"; //window.newlive

// 修改用户基础信息
export const apiUpdateUserInfo = (params = {}) => {
  params.service = "PCUser.updateFields";
  params = jsonToFormData(params);
  let uid = localStorage.getItem("uid");
  let token = localStorage.getItem("token");
  params.append("uid", uid);
  params.append("token", token);
  return axios.post(baseUrl + "/", params, formDataConfig);
};

// 修改用户头像
export const apiUpdatePhoto = ({ file }) => {
  console.log(file);
  let param = new FormData();
  let uid = localStorage.getItem("uid");
  let token = localStorage.getItem("token");
  param.append("file", file);
  param.append("uid", uid);
  param.append("token", token);
  param.append("service", "PCUser.UpdateAvatar");
  return axios.post(baseUrl + "/", param, formDataConfig);
};

// 获取礼物列表
export const apiGiftList = (params = {}) => {
  params = merge(params, "Live.GetGiftList");
  return axios.post(baseUrl + "/", params);
};
// 赠送礼物
export const apiSendGift = (params = {}) => {
  params = merge(params, "Live.SendGift");
  return axios.post(baseUrl + "/", params);
};
// 修改用户密码
export const apiUpdatePsw = (params = {}) => {
  params = merge(params, "PCUser.UpdatePass");
  return axios.post(baseUrl + "/", params);
};
// 获取底部信息
export const apiGetFootMsg = (params = {}) => {
  params = merge(params, "PCUser.getPerSetting");
  return axios.post(baseUrl + "/", params);
};

// 获取我的关注列表
export const apiGetFollowsList = (params = {}) => {
  params = merge(params, "PCUser.GetFollowsList");
  return axios.post(baseUrl + "/", params);
};

// 关注/取消关注
export const apiToAttent = (params = {}) => {
  params = merge(params, "PCUser.SetAttent");
  return axios.post(baseUrl + "/", params);
};

// 获取粉丝列表
export const apiGetMyfansList = (params = {}) => {
  params = merge(params, "PCUser.GetFansList");
  return axios.post(baseUrl + "/", params);
};

// 获取我是管理员的直播间列表
export const apiGetMyRoomList = (params = {}) => {
  params = merge(params, "PCLivemanage.GetRoomList");
  return axios.post(baseUrl + "/", params);
};

// 解除禁言
export const apiCancelShut = (params = {}) => {
  params = merge(params, "PCLivemanage.CancelShut");
  return axios.post(baseUrl + "/", params);
};

// 用于获取房间禁言用户列表
export const apiGetShutList = (params = {}) => {
  params = merge(params, "PCLivemanage.GetShutList");
  return axios.post(baseUrl + "/", params);
};

// 用于获取房间踢出用户列表
export const apiGetKickList = (params = {}) => {
  params = merge(params, "PCLivemanage.GetKickList");
  return axios.post(baseUrl + "/", params);
};

// 获取我的管理员列表
export const apiGetMyManagerList = (params = {}) => {
  params = merge(params, "PCLivemanage.getManageList");
  return axios.post(baseUrl + "/", params);
};

// 移除管理员
export const apiRemoveManager = (params = {}) => {
  params = merge(params, "PCLivemanage.cancelManage");
  return axios.post(baseUrl + "/", params);
};

// 获取我的直播记录
export const apiGetLiverecord = (params = {}) => {
  params = merge(params, "PCUser.getLiverecord");
  if (!params.starttime) {
    let now = new Date();
    params.starttime = Math.floor(
      new Date(now.setHours(0, 0, 0, 0)).getTime() / 1000
    );
  }
  if (!params.endtime) {
    params.endtime = Math.floor(new Date().getTime() / 1000);
  }
  return axios.post(baseUrl + "/", params);
};

// 注册 - 检测用户是否存在
export const apiCheckUserExists = (params = {}) => {
  params = merge(params, "PCLogin.checkUserExists");
  return axios.post(baseUrl + "/", params);
};

/**
 *  首页 -> 主播推荐列表获取
 */
export const apiGetRecommendAnchor = (params = {}) => {
  params = merge(params, "PCHome.GetRecommendAnchor");
  return axios.post(baseUrl + "/", params);
};

// 首页 -> 获取热门主播
export const apiGetHot = (params = {}) => {
  params = merge(params, "PCHome.GetHot");
  return axios.post(baseUrl + "/", params);
};

// 订阅推荐主播
export const apiSubscribeAnchor = (params = {}) => {
  params = merge(params, "PCHome.SubscribeAnchor");
  return axios.post(baseUrl + "/", params);
};

// 获取订阅主播列表
export const apiGetSubscribe = (params = {}) => {
  params = merge(params, "PCUser.GetSubscribe");
  return axios.post(baseUrl + "/", params);
};

// 获取广告
export const apiGetAdList = (params = {}) => {
  params = merge(params, "Slide.GetSlide");
  return axios.post(baseUrl + "/", params);
};

// 获取广告点击
export const apiClickAd = (params = {}) => {
  params = merge(params, "Slide.ClickSlideItem");
  return axios.post(baseUrl + "/", params);
};

// 获取首页数据 banner 公告 赛事
export const apiGetHomeData = (params = {}) => {
  params = merge(params, "PCHome.getHomeData");
  return axios.post(baseUrl + "/", params);
};

// 获取主播列表
export const apiGetRecommendedStream = (params = {}) => {
  params = merge(params, "PCHome.GetRecommendedStream");
  return axios.post(baseUrl + "/", params);
};

// 获取篮球比赛列表 -- 全部
export const apiGetMatchAllList = (params = {}) => {
  return axios.get(api.getMatchAllList, { params });
};

// 获取足球比赛列表 -- 全部
export const footballList = (params = {}) => {
  return axios.get(api.footballList, { params });
};

// 获取篮球比赛列表 -- 进行中
export const basketballPlayingList = (params = {}) => {
  return axios.get(api.basketballPlayingList, { params });
};

// 获取足球比赛列表 -- 进行中
export const footballPlayingList = (params = {}) => {
  return axios.get(api.footballPlayingList, { params });
};

// 获取篮球比赛列表 -- 进行中
export const basketballListByDate = (params = {}) => {
  return axios.get(api.basketballListByDate, { params });
};

// 获取足球比赛列表 -- 进行中
export const footballListByDate = (params = {}) => {
  return axios.get(api.footballListByDate, { params });
};

// 获取BONGDA数据列表
export const liveSportsList = (params = {}) => {
  return axios.get(api.liveSportsList, { params });
};
//获取BONGDA列表pc端
export const liveSportsPcList = (params = {}) => {
  return axios.get(api.liveSportsPcList, { params });
};
//获取首页赛事预览pc端
export const sportgetHomeData = (params = {}) => {
  return axios.get(api.sportgetHomeData, { params });
};

// 获取 推单列表数据
export const pushOrder = (params = {}) => {
  params = merge(params, "Live.GetTeidanList");
  return axios.post(baseUrl + "/", params);
};
// 推单 跟单 反买
export const followBackBuy = (params = {}) => {
  params = merge(params, "Live.TeidanVote");
  return axios.post(baseUrl + "/", params);
};

// 获取 推单列表
export const pushOrderList = (params = {}) => {
  params = merge(params, "Teidan.TeidanList");
  return axios.post(baseUrl + "/", params);
};
// 获取 推单分类列表
export const tuidanCatList = (params = {}) => {
  params = merge(params, "Teidan.TeidanCatList");
  return axios.post(baseUrl + "/", params);
};
// 获取 推单状态
export const teidanStatusList = (params = {}) => {
  params = merge(params, "Teidan.TeidanStatusList");
  return axios.post(baseUrl + "/", params);
};
// 获取 删除推单
export const delTeidan = (params = {}) => {
  params = merge(params, "Teidan.DelTeidan");
  return axios.post(baseUrl + "/", params);
};
// 新增推单
export const addTeidan = (params = {}) => {
  params = merge(params, "Teidan.AddTeidan");
  return axios.post(baseUrl + "/", params);
};
// 修改推单
export const editTeidan = (params = {}) => {
  params = merge(params, "Teidan.EditTeidan");
  return axios.post(baseUrl + "/", params);
};

//统计app下载点击次数
export const clickStatistics = (params = {}) => {
  return axios.get(api.clickStatistics, { params });
};
function buildFormData(formData, data, parentKey) {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    const value = data == null ? "" : data;
    formData.append(parentKey, value);
  }
}

function jsonToFormData(data = {}, deep) {
  const formData = new FormData();
  if (deep) {
    buildFormData(formData, data);
  } else {
    for (var key in data) {
      formData.append(
        key,
        typeof data[key] === "object" ? JSON.stringify(data[key]) : data[key]
      );
    }
  }
  return formData;
}

function merge(params, data) {
  if (typeof data === "object") {
    return Object.assign(params, data);
  } else {
    return Object.assign(params, { service: data });
  }
}

// 获取新版足球比赛列表 -- 全部
export const NewfootballAllList = (params = {}) => {
  return axios.get(api.NewfootballAllList, { params });
};
// 获取新版足球比赛列表 -- 进行中
export const NewfootballPlayingList = (params = {}) => {
  return axios.get(api.NewfootballPlayingList, { params });
};
// 获取新版足球比赛列表 -- 最热
export const NewfootballHotList = (params = {}) => {
  return axios.get(api.NewfootballHotList, { params });
};
// 获取新版足球比赛列表 -- 日期
export const NewfootballDateList = (params = {}) => {
  return axios.get(api.NewfootballDateList, { params });
};
// 获取新版足球比赛数量汇总
export const NewfootballMatchSum = (params = {}) => {
  return axios.get(api.NewfootballMatchSum, { params });
};
// 获取新版篮球比赛列表 -- 全部
export const NewbasketballAllList = (params = {}) => {
  return axios.get(api.NewbasketballAllList, { params });
};
// 获取新版篮球比赛列表 -- 进行中
export const NewbasketballPlayingList = (params = {}) => {
  return axios.get(api.NewbasketballPlayingList, { params });
};
// 获取新版篮球比赛列表 -- 最热
export const NewbasketballHotList = (params = {}) => {
  return axios.get(api.NewbasketballHotList, { params });
};
// 获取新版篮球比赛列表 -- 日期
export const NewbasketballDateList = (params = {}) => {
  return axios.get(api.NewbasketballDateList, { params });
};
// 获取新版篮球比赛数量汇总
export const NewbasketballMatchSum = (params = {}) => {
  return axios.get(api.NewbasketballMatchSum, { params });
};



// WEBPACK FOOTER //
// ./src/http/index.js